import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import { Compress } from '@/components/Icons/Compress';
import { FileClose } from '@/components/Icons/FileClose';
import { FileForUpload } from '@/components/Icons/FileForUpload';
import { LoadingIcon } from '@/components/Icons/LoadingIcon';
import { Pdf } from '@/components/Icons/Pdf';
import { Powerpoint } from '@/components/Icons/Powerpoint';
import { Retry } from '@/components/Icons/Retry';
import { Word } from '@/components/Icons/Word';
import { fileContainsUploadUrlSelector, fileHasUploadErrorSelector, isMobileSelector, } from '@/state/session';
import styles from './FilesCarousel.module.scss';
export const UploadCard = ({ fileName, fileType, handleClose, id }) => {
    const hasUploadUrl = useRecoilValue(fileContainsUploadUrlSelector(id));
    const hasUploadError = useRecoilValue(fileHasUploadErrorSelector(id));
    const isMobile = useRecoilValue(isMobileSelector);
    const handleCloseButton = useCallback((e) => {
        e.preventDefault();
        if (handleClose) {
            handleClose(e);
        }
    }, [handleClose]);
    const iconByType = (fileType) => {
        const size = 36;
        switch (fileType) {
            case 'pdf':
                return _jsx(Pdf, { size: size });
            case 'doc':
            case 'docx':
                return _jsx(Word, { size: size });
            case 'ppt':
            case 'pptx':
                return _jsx(Powerpoint, { size: size });
            case 'zip':
            case 'rar':
                return _jsx(Compress, { size: size });
            default:
                return _jsx(FileForUpload, { size: size });
        }
    };
    const renderIcon = () => {
        if (hasUploadUrl && !hasUploadError) {
            return _jsx("div", { className: styles.file, children: iconByType(fileType) });
        }
        if (!hasUploadUrl || hasUploadError) {
            return (_jsx("div", { className: cn(styles.file, {
                    [styles.dark]: hasUploadError || !hasUploadUrl,
                    [styles.pointer]: hasUploadError,
                }), children: !hasUploadUrl ? _jsx(LoadingIcon, { size: "small" }) : _jsx(Retry, { size: 16 }) }));
        }
    };
    return (_jsxs("div", { className: cn(styles.card, 'keen-slider__slide', {
            [styles.mobile]: isMobile,
        }), style: {
            position: 'relative',
            opacity: hasUploadUrl ? 1 : 0.5,
            filter: hasUploadError ? 'grayscale(100%)' : 'none',
        }, children: [renderIcon(), _jsxs("div", { className: styles.data, children: [_jsx("span", { className: styles.name, children: fileName }), _jsx("span", { className: styles.type, children: fileType })] }), hasUploadUrl && (_jsx("span", { className: styles.closeIcon, role: "button", onClick: handleCloseButton, onKeyDown: handleCloseButton, tabIndex: 0, children: _jsx(FileClose, {}) }))] }));
};
